export enum UploadFileType {
    ProfilePicture,
    Content,
    ProjectPicture,
    CampaignDocument,
    SynnerDocument,
    ReportFile,
}
